"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const onigasmH_1 = require("./onigasmH");
exports.loadWASM = onigasmH_1.loadWASM;
const OnigRegExp_1 = require("./OnigRegExp");
exports.OnigRegExp = OnigRegExp_1.default;
const OnigScanner_1 = require("./OnigScanner");
exports.OnigScanner = OnigScanner_1.default;
const OnigString_1 = require("./OnigString");
exports.OnigString = OnigString_1.default;
//# sourceMappingURL=index.js.map